// wwwroot/js/src/ark-motion.js
//
// 动效开关的 DOM 落点：把「宿主设置」与「系统减少动态效果」合并成 <html data-motion="on|off"> 一个属性，
// CSS（ark-motion.css）只认这一个属性。规范见 docs/design/客户端界面/动效规范.md §4。
//
// 宿主设置镜像在 localStorage（Ark_Ui_Motion_Enabled = "true" | "false"），供首帧前的内联脚本预设
// （Ark.Client/wwwroot/index.html）。没有宿主设置的站点（Admin）缺省为开，只受系统偏好影响。

window.ArkUI = window.ArkUI || {};

(function () {
    const STORAGE_KEY = 'Ark_Ui_Motion_Enabled';
    const mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function readSetting() {
        try {
            return localStorage.getItem(STORAGE_KEY) !== 'false';
        } catch (e) {
            return true;
        }
    }

    let setting = readSetting();

    function apply() {
        const off = !setting || (mq !== null && mq.matches);
        document.documentElement.setAttribute('data-motion', off ? 'off' : 'on');
    }

    window.ArkUI.Motion = {
        /** 宿主设置变更（C# MotionService.SetEnabledAsync 调用）：写镜像 + 立即落到 DOM */
        set(enabled) {
            setting = !!enabled;
            try { localStorage.setItem(STORAGE_KEY, setting ? 'true' : 'false'); } catch (e) { /* 隐私模式 */ }
            apply();
        },

        /** 当前是否播放动效（其他 JS 模块据此跳过 setTimeout 等待，见 ark-floating / ark-swipe-action） */
        enabled() {
            return document.documentElement.getAttribute('data-motion') !== 'off';
        },

        /**
         * 退场残影：把即将被 Blazor 移除的节点克隆一份静态副本挂到 body，淡出后自删。
         *
         * 为什么不是「延迟卸载组件」：弹窗关闭时结果已经交还调用方，调用方会立刻清状态（清购物车、跳页）；
         * 组件若再多活 100ms，任何一次重渲染都可能读到已清空的状态。残影是纯 DOM、不接事件、不跑 C#，
         * 真组件照常立即卸载 —— 业务链路零等待、零状态风险（动效规范.md §2②）。
         *
         * 调用方必须在「移除该节点的那次渲染」之前 await 本函数（它是同步完成的，只为保证先后顺序）。
         * 只适用于视口级 fixed 元素：克隆挂在 body 上，absolute 定位的内联浮层会错位，调用方自行排除。
         */
        ghostExit(el) {
            if (!el || !el.isConnected || !this.enabled()) return;

            const clone = el.cloneNode(true);

            // cloneNode 不带运行时状态：滚动位置与输入框当前值要手工搬，否则残影会先「跳回顶部」再淡出
            const src = [el, ...el.querySelectorAll('*')];
            const dst = [clone, ...clone.querySelectorAll('*')];
            const scrolls = [];
            for (let i = 0; i < src.length && i < dst.length; i++) {
                const s = src[i];
                if (s.scrollTop || s.scrollLeft) scrolls.push([dst[i], s.scrollTop, s.scrollLeft]);
                if ('value' in s && typeof s.value === 'string' && s.tagName !== 'BUTTON') {
                    try { dst[i].value = s.value; } catch (e) { /* file input 等只读 value */ }
                }
                dst[i].removeAttribute('id');   // 残影存活期间不与真节点撞 id（aria-labelledby 等）
            }

            clone.setAttribute('aria-hidden', 'true');
            clone.inert = true;
            clone.style.zIndex = getComputedStyle(el).zIndex;
            clone.classList.add('ark-m-ghost');
            document.body.appendChild(clone);
            for (const [node, top, left] of scrolls) {
                node.scrollTop = top;
                node.scrollLeft = left;
            }

            // exit 档 100ms + 一帧余量（MotionTokens.ExitMs + FrameSlackMs）；animationend 为主、定时器兜底
            let removed = false;
            const remove = () => { if (!removed) { removed = true; clone.remove(); } };
            clone.addEventListener('animationend', e => { if (e.target === clone) remove(); });
            setTimeout(remove, 120);
        },
    };

    apply();
    if (mq !== null && mq.addEventListener) mq.addEventListener('change', apply);
})();
